import styles from "./Spinner.module.css";

// Feedback / Loading из Figma (узел 577:2585): 12 штрихов по часовой стрелке от 12 часов.
// Самый тёмный штрих (на 9 часах) — «голова», за ней хвост светлеет против часовой стрелки.
const spinnerColors = [
  "#d2e3ff",
  "#bdd7ff",
  "#b0cffe",
  "#98bef9",
  "#88b5fe",
  "#6da5ff",
  "#5b9afe",
  "#468cff",
  "#1568ec",
  "#0451ca",
  "#f3f8ff",
  "#e6f0ff",
];

/** Индикатор загрузки; доступное имя задаёт обёртка (`role="status"`) или кнопка. */
export function Spinner({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={[styles.spinner, className].filter(Boolean).join(" ")}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      {spinnerColors.map((color, index) => (
        <rect
          key={color}
          x="9.17"
          y="0"
          width="1.67"
          height="5"
          rx="0.83"
          fill={color}
          transform={`rotate(${index * 30} 10 10)`}
        />
      ))}
    </svg>
  );
}
